import odata from '@/core/api/mixin/odata'
import rest from '@/core/api/mixin/rest'
import { apiClient } from '@/core/api/httpClient'

export default {
  ...odata('acl_entities'),
  ...rest('acl_entities'),
  getPermissions: async () => {
    return await apiClient.get('/permissions')
  },
  getDomains: async () => {
    return await apiClient.get('/domains')
  },
  getRoutesAclEntities: async () => {
    return await apiClient.get('/acl_entities', {
      params: {
        $expand: 'permission',
      },
    })
  },
}
